export type BackgroundColorKey =
    | "light grey"
    | "dark grey"
    | "dark purple"
    | "light purple"
    | "mid purple"
    | "purple"
    | "light purple to dark purple"
    | "dark purple to light purple"
    | "light purple to light blue"
    | "rainbow blue to purple"
    | "rainbow purple to blue"
    | "dark purple inverted";

/**
 * Maps Strapi backgroundColor → CSS background
 */
export const backgroundColorMap: Record<
    BackgroundColorKey,
    string
> = {
    "light grey": "#f3f3f9",
    "dark grey": "#263244",
    "dark purple": "#3d168d",
    "light purple": "#E6DCFF",
    "mid purple": "#6B4EFF",
    "purple": "#5A2D82",

    "light purple to dark purple":
        "linear-gradient(180deg, #E6DCFF 0%, #2E1A47 100%)",

    "dark purple to light purple":
        "linear-gradient(180deg, #2E1A47 0%, #E6DCFF 100%)",

    "light purple to light blue":
        "linear-gradient(180deg, #E4CEF8 0%, #E8F9F8 100%)",

    "rainbow blue to purple":
        "linear-gradient(90deg, #E8F9F8 0%, #E4CEF8 100%)",

    "rainbow purple to blue":
        "linear-gradient(90deg, #E4CEF8 0%, #E8F9F8 100%)",

    "dark purple inverted": "#2E1A47",
};

/**
 * Safe resolver
 */
export function getBackgroundColor(
    backgroundColor?: string
) {
    if (!backgroundColor) return "#ffffff";

    return (
        backgroundColorMap[
            backgroundColor as BackgroundColorKey
        ] ?? "#ffffff"
    );
}
